export default __webpack_public_path__ + "static/media/546.cb484057.gif";